<template>
  <div 
    :id="id"
    class="table-row"
    :style="style"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    id: { type: String, default: '' },
    height: { type: String, default: '100%' },
  },

  computed: {
    style() {
      return `height: ${this.height}`
    },
  },
})
</script>

<style lang="scss" scoped>
.table-row {
  white-space: nowrap;
  transform: translateZ(0);
}
</style>
